<template>
  <div>
    <v-container>
      <v-form>
        <v-row>
          <v-col>
            <h2 class="pb-5">
              {{ this.parentObject.pageTitle }}
              <span class="page_title_value">{{
                this.parentObject.pageTitleValue
              }}</span>
            </h2>
          </v-col>
        </v-row>

        <!-- <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        > -->
        <v-row v-if="!this.formData.lockstaff">
          <v-col cols="4" sm="10" class="pb-n5 mt-n6">
            <v-autocomplete
              outlined
              :label="this.$t('columns.name')"
              type="text"
              ref="psnid"
              :rules="[rules.required]"
              v-model="formData.staffid"
              dense
              :items="staffDetailsList"
              @input="updateValue"
              @change="changeStaffIDandCompanyHandler(formData.staffid)"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="4" sm="10" class="pb-n5 mt-n6">
            <v-autocomplete
              outlined
              :label="this.$t('columns.name')"
              type="text"
              ref="psnid"
              :rules="[rules.required]"
              v-model="formData.staffid"
              dense
              :items="staffDetailsList"
              readonly
              background-color="#ffeab2"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="8" sm="5" class="pb-n5 mt-n6">
            <v-text-field
              outlined
              :label="this.$t('columns.staffid')"
              type="text"
              :rules="[rules.required]"
              v-model="formData.staffcode"
              dense
              readonly
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>

          <v-col cols="8" sm="5" class="pb-n5 mt-n6">
            <v-text-field
              outlined
              :label="this.$t('columns.company')"
              type="text"
              ref="compnyid"
              v-model="formData.compnyname"
              dense
              readonly
              append-icon=""
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="5" sm="5" class="pb-n5 mt-n6">
            <v-text-field
              outlined
              :label="this.$t('columns.date')"
              type="date"
              ref="clockdate"
              :rules="[rules.required]"
              v-model="formData.clockdate"
              @change="updateValue"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="5" sm="5" class="pb-n5 mt-n6">
            <v-text-field
              outlined
              :label="this.$t('payrollsummarylistingreport.time')"
              type="time"
              ref="clocktime"
              :rules="[rules.required]"
              v-model="formData.clocktime"
              @change="updateValue"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="5" class="pb-n5 mt-n6">
            <v-autocomplete
              outlined
              :label="this.$t('clockdata.device')"
              type="text"
              ref="devicecode"
              v-model="formData.device"
              dense
              :items="devicelist"
              @change="changeDevice(formData.device)"
            ></v-autocomplete>
          </v-col>

          <v-col cols="4" class="pb-n5 mt-n6">
            <v-text-field
              outlined
              :label="this.$t('clockdata.devicecode')"
              type="text"
              ref="devicecode"
              v-model="formData.devicecode"
              dense
              readonly
              append-icon=""
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>

          <v-col cols="1" class="pb-n5 mt-n6">
              <v-dialog v-model="deviceDialog" max-width="500px" persistent>
                  <template v-slot:activator="{ on }">
                      <v-btn dense v-on="on">
                          <v-icon>edit</v-icon>
                      </v-btn>
                  </template>
                  <v-card>
                    <app-genericform 
                          v-bind:parentData = "{
                              tabItems: deviceItems,
                              formTitle: `${this.$t('clockdata.device')}`,
                              formId: 'device'
                          }"
                          v-on:input="itemData = $event"
                          v-on:saveDevice="saveDeviceHandler"
                          v-on:deleteDevice="deleteDeviceHandler($event)"
                      />

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                              color="warning"
                              text
                              @click="deviceDialog = false"
                          >
                          {{$t('button.close')}}
                          </v-btn>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4" class="pb-n5 mt-n6">
            <v-text-field
              outlined
              :label="this.$t('clockdata.inout')"
              type="text"
              ref="indicator"
              v-model="formData.indicator"
              dense
              @input="updateValue"
            ></v-text-field>
            <!-- :rules="[rules.required]" -->
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="5" class="pb-n5 mt-n6">
            <v-autocomplete
              outlined
              :label="this.$t('columns.reason')"
              type="text"
              ref="reason"
              v-model="formData.reason"
              dense
              :items="reasonlist"
              @change="changeReason(formData.reason)"
            ></v-autocomplete>
          </v-col>

          <v-col cols="4" class="pb-n5 mt-n6">
            <v-text-field
              outlined
              :label="this.$t('generateunpaidleaverecord.reasoncode')"
              type="text"
              ref="reasoncode"
              v-model="formData.reasoncode"
              dense
              readonly
              append-icon=""
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>
          <v-col cols="1" class="pb-n5 mt-n6">
              <v-dialog v-model="reasonDialog" max-width="500px" persistent>
                  <template v-slot:activator="{ on }">
                      <v-btn dense v-on="on">
                          <v-icon>edit</v-icon>
                      </v-btn>
                  </template>
                  <v-card>
                    <app-genericform 
                          v-bind:parentData = "{
                              tabItems: reasonItems,
                              formTitle: `${this.$t('columns.reason')}`,
                              formId: 'clockreason'
                          }"
                          v-on:input="itemData = $event"
                          v-on:saveReason="saveReasonHandler"
                          v-on:deleteReason="deleteReasonHandler($event)"
                      />

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                              color="warning"
                              text
                              @click="reasonDialog = false"
                          >
                          {{$t('button.close')}}
                          </v-btn>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
          </v-col>
        </v-row>

        <v-row v-if="isEdit">
          <v-col cols="4" sm="4" class="pb-n5 mt-n6">
            <v-text-field
              outlined
              :label="this.$t('clockdata.uploadtime')"
              type="text"
              ref="uploadedtime"
              v-model="formData.uploadedtime"
              @change="updateValue"
              dense
              readonly
              append-icon=""
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>
          <v-col cols="3" sm="3" class="pb-n5 mt-n6">
            <v-text-field
              outlined
              :label="this.$t('clockdata.source')"
              type="text"
              ref="datesource"
              v-model="formData.datesource"
              dense
              readonly
              append-icon=""
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>
        </v-row>
        <app-formbuttons
          v-bind:EditBool="this.parentObject.isEdit"
          v-on:NewPressed="newHandler"
          v-on:SavePressed="saveHandler"
          v-on:DeletePressed="deleteHandler"
          v-on:CancelPressed="cancelHandler"
        />
      </v-form>
    </v-container>
    <div v-if="isErrTrigger">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErrTrigger,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import ErrorDialog from "../../../components/common/ErrorDialog";
// import moment from "moment";
// import VueTimepicker from "vue2-timepicker";
import GenericForm from '../../generic/GridForm';

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
    'app-genericform': GenericForm,
    // "vue-timepicker": VueTimepicker,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
        },
      },
      formData: {
        id: this.parentObject.data.id,
        staffid: this.parentObject.data.staffid,
        staffcode: this.parentObject.data.staffcode,
        psnname: this.parentObject.data.psnname,
        clockdate: this.parentObject.data.clockdate,
        clocktime: this.parentObject.data.clocktime,
        indicator: this.parentObject.data.indicator,
        device: this.parentObject.data.device,
        devicecode: this.parentObject.data.devicecode,
        devicedesc: this.parentObject.data.devicedesc,
        reason: this.parentObject.data.reason,
        reasoncode: this.parentObject.data.reasoncode,
        reasondesc: this.parentObject.data.reasondesc,
        datesource: this.parentObject.data.datesource,
        uploadedtime: this.parentObject.data.uploadedtime,
        search: this.parentObject.data.search,
        stamp: this.parentObject.data.stamp,
        userid: this.$store.getters.userId,
      },

      device: [],
      devicelist: [],
      deviceItems: [],
      deviceDialog: false,

      reason: [],
      reasonlist: [],
      reasonItems: [],
      reasonDialog: false,

      staffDetailsList: [],

      errMsg: "",
      isErr: false,
      isErrTrigger: false,
      isEdit: this.parentObject.isEdit,
      search: this.parentObject.searchnew
    };
  },

  methods: {
    updateValue() {
      this.$emit("input", {
        id: this.formData.id,
        staffid: this.formData.staffid,
        staffcode: this.formData.staffcode,
        psnname: this.formData.psnname,
        clockdate: this.formData.clockdate,
        clocktime: this.formData.clocktime,
        indicator: this.formData.indicator,
        device: this.formData.device,
        devicecode: this.formData.devicecode,
        devicedesc: this.formData.devicedesc,
        reason: this.formData.reason,
        reasoncode: this.formData.reasoncode,
        reasondesc: this.formData.reasondesc,
        datesource: this.formData.datesource,
        uploadedtime: this.formData.uploadedtime,
        search: this.formData.search,
        stamp: this.formData.stamp,
        userid: this.$store.getters.userId,
      });
    },

    //load staffdetails list view
    loadStaffDetailsListHandler() {
      const vm = this;
      this.$store.dispatch('get', {
          url: `/staff/all/${this.$store.getters.userId}`
        })
        .then((res) => {
          //req success --> push res into array
          vm.staffdetails = res.data.rec;

          for (let i = 0; i < res.data.rec.length; i++) {
            vm.staffDetailsList.push({
              text: res.data.rec[i].psndetails,
              value: res.data.rec[i].id,
            });
          }

          if (vm.formData.staffid) {
            this.changeStaffIDandCompanyHandler(vm.formData.staffid);
          }
        })
        .catch((err) => {
          //req failure --> emit error
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },

    //change staff id and company after selecting psnnid
    changeStaffIDandCompanyHandler(id) {
      let item = this.staffdetails.find((item) => item.id === id);

      //set psnid to psnid and staffid to staffid
      this.formData.psnid = item.psnid;
      this.formData.staffid = item.id;
      this.formData.staffcode = item.staffcode;
      this.formData.compnyid = item.compnyid;
      this.formData.compnyname = item.compnyname;

      this.updateValue();
    },

    loadDeviceListHandler() {
      const vm = this;
      this.$store.dispatch('get', {
          url: `/device/all`
        })
        .then((res) => {
          //req success --> push res into array
          vm.device = res.data.rec;

          for (let i = 0; i < res.data.rec.length; i++) {
            vm.devicelist.push({
              text: res.data.rec[i].devicedesc,
              value: res.data.rec[i].id,
            });

            vm.deviceItems.push(
                {
                    id: res.data.rec[i].id,
                    code: res.data.rec[i].devicecode,
                    desc: res.data.rec[i].devicedesc,
                    stamp: res.data.rec[i].stamp
                }
            )

            if (vm.formData.device) {
              this.changeDevice(vm.formData.device);
            }
          }
        })
        .catch((err) => {
          //req failure --> emit error
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },
    changeDevice(id) {
      let item = this.device.find((item) => item.id === id);
      this.formData.device = item.id;
      this.formData.devicecode = item.devicecode;
      this.updateValue();
    },

    saveDeviceHandler() {
        let vm = this;

        if (this.itemData.itemid) {
            this.$store.dispatch('put', {url: '/device/' + this.itemData.itemid, payload: {
                devicecode: vm.itemData.itemcode,
                devicedesc: vm.itemData.itemdesc,
                stamp: vm.itemData.itemstamp
            }})
            .then(res => {
                if (res.data.status == 201) {
                    // reset all arrays
                    vm.device = [];
                    vm.devicelist = [],
                    vm.deviceItems = [],

                    this.loadDeviceListHandler();
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        } else {
            this.$store.dispatch('post', {url: '/device/create', payload: {
                devicecode: vm.itemData.itemcode,
                devicedesc: vm.itemData.itemdesc
            }})
            .then(res => {
                if (res.data.status == 201) {
                    // reset all arrays
                    vm.device = [];
                    vm.devicelist = [],
                    vm.deviceItems = [],

                    this.loadDeviceListHandler();
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        }
    },

    deleteDeviceHandler($event) {
        let vm = this;

        if (confirm('Remove ' + $event.desc + '?')) {
            this.$store.dispatch('delete', {url: '/device/' + $event.id + '/' + this.$store.getters.userId})
            .then(res => {
                if (res.data.status == 200) {
                    // reset all arrays
                    vm.device = [];
                    vm.devicelist = [],
                    vm.deviceItems = [],

                    this.loadDeviceListHandler();
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        }
    },

    loadReasonListHandler() {
      const vm = this;
      this.$store.dispatch('get', {
          url: `/clockreason/all`
        })
        .then((res) => {
          //req success --> push res into array
          vm.reason = res.data.rec;

          for (let i = 0; i < res.data.rec.length; i++) {
            vm.reasonlist.push({
              text: res.data.rec[i].reasondesc,
              value: res.data.rec[i].id,
            });

            vm.reasonItems.push(
                {
                    id: res.data.rec[i].id,
                    code: res.data.rec[i].reasoncode,
                    desc: res.data.rec[i].reasondesc,
                    stamp: res.data.rec[i].stamp
                }
            )

            if (vm.formData.reason) {
              this.changeReason(vm.formData.reason);
            }
          }
        })
        .catch((err) => {
          //req failure --> emit error
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },
    changeReason(id) {
      let item = this.reason.find((item) => item.id === id);
      this.formData.reason = item.id;
      this.formData.reasoncode = item.reasoncode;
      this.updateValue();
    },
    saveReasonHandler() {
        let vm = this;

        if (this.itemData.itemid) {
            this.$store.dispatch('put', {url: '/clockreason/' + this.itemData.itemid, payload: {
                reasoncode: vm.itemData.itemcode,
                reasondesc: vm.itemData.itemdesc,
                stamp: vm.itemData.itemstamp
            }})
            .then(res => {
                if (res.data.status == 201) {
                    // reset all arrays
                    vm.reason = [];
                    vm.reasonlist = [],
                    vm.reasonItems = [],

                    this.loadReasonListHandler();
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        } else {
            this.$store.dispatch('post', {url: '/clockreason/create', payload: {
                reasoncode: vm.itemData.itemcode,
                reasondesc: vm.itemData.itemdesc
            }})
            .then(res => {
                if (res.data.status == 201) {
                    // reset all arrays
                    vm.reason = [];
                    vm.reasonlist = [],
                    vm.reasonItems = [],

                    this.loadReasonListHandler();
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        }
    },

    deleteReasonHandler($event) {
        let vm = this;

        if (confirm('Remove ' + $event.desc + '?')) {
            this.$store.dispatch('delete', {url: '/clockreason/' + $event.id + '/' + this.$store.getters.userId})
            .then(res => {
                if (res.data.status == 200) {
                    // reset all arrays
                    vm.reason = [];
                    vm.reasonlist = [],
                    vm.reasonItems = [],

                    this.loadReasonListHandler();
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        }
    },

    newHandler() {
      this.$emit("new");
    },

    saveHandler() {
      this.$emit("save");
    },

    deleteHandler() {
      this.$emit("delete");
    },

    cancelHandler() {
      this.$router.push({ name: "clockdatalist" , params: { search: this.search}});
    },

  },

  mounted() {
    this.loadStaffDetailsListHandler();
    this.loadDeviceListHandler();
    this.loadReasonListHandler();
  },
};
</script>

<!-- numberfield style class to remove buttons in number type field  -->
<style>
.numberfield input[type="number"] {
  -moz-appearance: textfield;
}
.numberfield input::-webkit-outer-spin-button,
.numberfield input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>